import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SimulationPack } from '@app/dashboard/sheets/shared/ea-simulation-packs/simulation-pack.service';
import { SwiperOptions } from 'swiper';
import { UtilsService } from '@app/providers/utils/utils.service';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'management-mandate',
    templateUrl: './management-mandate.component.html',
    styleUrls: ['./management-mandate.component.scss'],
    standalone: false
})
export class ManagementMandateComponent implements OnInit {
  @ViewChild('swiper', { read: ElementRef }) swiper?: ElementRef;
  selectedPack;

  public config: SwiperOptions = {
    a11y: { enabled: true },
    direction: 'horizontal',
    slidesPerView: 1.05,
    keyboard: true,
    mousewheel: true,
    pagination: true,
    touchStartPreventDefault: true,
    centeredSlides: false,
    spaceBetween: 10,
    slidesOffsetBefore: 10,
    slidesOffsetAfter: 10,
    threshold: 0,
    breakpoints: {
      760: {
        slidesPerView: 2.1,
        centeredSlides: false,
      },
    },
  };

  packs: any[] = [
    {
      id: '1',
      allocation: [],
      name: 'Management Mandate',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio nulla orci, pharetra, sagittis. Tincidunt porta suspendisse congue nisl condimentum tortor. Nisi, felis, massa habitasse purus d',
      annualizedPerformance: 5,
      riskScore: 4,
      color: '#3376F6',
    },
    {
      id: '2',
      allocation: [],
      name: 'Management Mandate',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio nulla orci, pharetra, sagittis. Tincidunt porta suspendisse congue nisl condimentum tortor. Nisi, felis, massa habitasse purus d',
      annualizedPerformance: 5,
      riskScore: 4,
      color: '#3376F6',
    },
    {
      id: '3',
      allocation: [],
      name: 'Management Mandate',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio nulla orci, pharetra, sagittis. Tincidunt porta suspendisse congue nisl condimentum tortor. Nisi, felis, massa habitasse purus d',
      annualizedPerformance: 5,
      riskScore: 4,
      color: '#3376F6',
    },
  ];
  packsSwiper = [
    {
      performance: '0.034',
      value: 'Prudent',
      risk: '2',
      id: 'PRUDENT',
      nbSupports: '4',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio nulla orci, pharetra, sagittis. Tincidunt porta suspendisse congue nisl condimentum tortor. Nisi, felis, massa habitasse purus d',
    },
    {
      performance: '0.053',
      value: 'Equilibré',
      risk: '4',
      id: 'BALANCED',
      nbSupports: '4',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio nulla orci, pharetra, sagittis. Tincidunt porta suspendisse congue nisl condimentum tortor. Nisi, felis, massa habitasse purus d',
    },
    {
      performance: '0.074',
      value: 'Dynamique',
      risk: '6',
      id: 'DYNAMIC',
      nbSupports: '4',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio nulla orci, pharetra, sagittis. Tincidunt porta suspendisse congue nisl condimentum tortor. Nisi, felis, massa habitasse purus d',
    },
  ];
  constructor(
    public utils: UtilsService,
    public subscriptionFacade: SubscriptionFacadeService,
  ) {
    // Swiper initialization handled by vanilla JS in template
  }
  selectPack(pack: SimulationPack) {
    this.selectedPack = pack;
  }
  ngOnInit(): void {
    const mandatGestion =
      this.subscriptionFacade.getPledge()?.products[0]?.parameters
        ?.mandatGestion;

    this.selectedPack = this.packsSwiper.find(
      pack => pack.id === mandatGestion,
    );
  }
  extract() {
    const productId = this.subscriptionFacade.getPledge().products[0].productId;
    const pack = this.selectedPack as any;

    return [
      {
        ownerId: null,
        productId: productId,
        mandatGestion: pack.id,
        productPackId: null,
      },
    ];
  }
  onSubmit() {
    if (this.selectedPack.id) {
      this.subscriptionFacade.submitPledgeWithoutForm(this);
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
